import { AsyncPipe } from '@angular/common';
import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import {
  MAT_LEGACY_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialogModule,
} from '@angular/material/legacy-dialog';
import { MatStep, MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';

import { Observable, map } from 'rxjs';
import { Countertop } from '../../../models/cutting/countertop';
import { Cutout } from '../../../models/cutting/cutting-panel-outline.model';
import { CuttingStandardCutout } from '../../../models/cutting/cutting-standard-cutout.model';
import { CutoutAdderComponent } from './cutout-adder/cutout-adder.component';
import { StandardCutoutsComponent } from './standard-cutouts/standard-cutouts.component';

@Component({
  templateUrl: './plate-cutout-wizard-dialog.component.html',
  standalone: true,
  styles: [
    `
      :host ::ng-deep mat-horizontal-stepper .mat-horizontal-content-container {
        padding: 0;
      }
    `,
  ],
  imports: [
    MatDividerModule,
    MatToolbarModule,
    MatIconModule,
    MatStepperModule,
    MatLegacyDialogModule,
    MatLegacyButtonModule,
    StandardCutoutsComponent,
    AsyncPipe,
    CutoutAdderComponent,
  ],
})
export class PlateCutoutWizardDialogComponent implements AfterViewInit {
  @ViewChild(MatStepper, { static: true }) stepper: MatStepper;
  @ViewChild('schemaListStep', { static: true }) schemaListStep: MatStep;
  @ViewChild('adderStep', { static: true }) adderStep: MatStep;

  @ViewChild('cutoutAdder', { static: true }) cutoutAdder: CutoutAdderComponent;

  isInvalid$: Observable<boolean>;

  constructor(
    public dialogRef: MatDialogRef<PlateCutoutWizardDialogComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: Countertop
  ) {}

  ngAfterViewInit(): void {
    this.isInvalid$ = this.cutoutAdder.stateChanged$.pipe(map(res => !res));
  }

  getCoord(): Cutout {
    return this.cutoutAdder.cutout;
  }

  skipStep(): void {
    this.schemaListStep.completed = true;
    this.stepper.next();
  }

  standardSelectChange(item: CuttingStandardCutout): void {
    if (item) {
      this.cutoutAdder.schema = item;
    }
    this.skipStep();
  }
}
